import { render, staticRenderFns } from "./StraightTree.vue?vue&type=template&id=bfb22c8e&"
import script from "./StraightTree.vue?vue&type=script&lang=js&"
export * from "./StraightTree.vue?vue&type=script&lang=js&"
import style0 from "./StraightTree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports